import { Link, useNavigate } from "react-router-dom";

export function ProductCard({ p }) {
  const navigate = useNavigate();
  const minVar = (p.variants || []).reduce((m, v) => (m && m.price < v.price ? m : v), null);
  const startPrice = minVar ? minVar.price : p.price_usd || 0;
  const startOriginal = minVar?.original_price || p.original_price_usd || 0;
  // Coerce to strict booleans — otherwise `0` (a falsy NUMBER) short-circuits
  // through JSX chains like `{onSale && ...}` and renders a literal "0".
  const onSale = Boolean(p.on_sale || (startOriginal > 0 && startOriginal > startPrice));
  const discount = onSale && startOriginal ? Math.round(((startOriginal - startPrice) / startOriginal) * 100) : 0;

  return (
    <div className="product-card group cursor-pointer" data-testid={`product-card-${p.sku}`} onClick={() => navigate(`/shop/${p.sku}`)}>
      <div className="relative aspect-square bg-[var(--paper-2)] overflow-hidden">
        {p.image_url ? (
          <img src={p.image_url} alt={p.product_name} className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04] ${p.any_in_stock === false ? "grayscale opacity-60" : ""}`} loading="lazy" />
        ) : (
          <div className="w-full h-full grid place-items-center text-[var(--ink-muted)] font-mono text-[10px] uppercase tracking-[0.2em]">No Image</div>
        )}
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {p.any_in_stock === false && <span className="sale-badge" style={{ background: "var(--rust)", color: "#fff" }} data-testid={`out-of-stock-${p.sku}`}>Out of stock</span>}
          {onSale && discount > 0 && p.any_in_stock !== false && <span className="sale-badge">−{discount}%</span>}
        </div>
        {p.has_active_coa && (
          <div className="absolute bottom-3 right-3 bg-[var(--paper-3)]/90 backdrop-blur-sm border border-[var(--terra)]/60 px-2 py-0.5 rounded-full font-mono text-[10px] tracking-[0.14em] uppercase text-[var(--terra)]">
            COA · {p.latest_batch}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-[var(--ink-muted)]">{p.category}</div>
        <Link to={`/shop/${p.sku}`} onClick={(e) => e.stopPropagation()} className="block mt-1 font-display text-[19px] font-medium tracking-tight leading-tight group-hover:text-[var(--terra)] transition-colors">
          {p.product_name}
        </Link>
        {p.tagline && <div className="text-xs text-[var(--ink-muted)] mt-0.5 leading-snug">{p.tagline}</div>}
        <div className="mt-3 flex items-baseline gap-2">
          <div className="font-display text-xl font-semibold">${startPrice.toFixed(2)}</div>
          {onSale && startOriginal > startPrice && (
            <div className="text-sm text-[var(--ink-muted)] line-through font-mono">${startOriginal.toFixed(2)}</div>
          )}
          {(p.variants || []).length > 1 && (
            <div className="text-[10.5px] font-mono uppercase tracking-[0.16em] text-[var(--ink-muted)]">+{p.variants.length - 1} sizes</div>
          )}
        </div>
      </div>
    </div>
  );
}
